const pageNameKey = "oneShot";

export const oneShotEn = {
  [pageNameKey]: { oneShotAltText: "One Shot" },
};

export const oneShotPtBr = {
  [pageNameKey]: { oneShotAltText: "One Shot" },
};

export const oneShotDe = {
  [pageNameKey]: { oneShotAltText: "One Shot" },
};

export const oneShotZhHans = {
  [pageNameKey]: { oneShotAltText: "一次性" },
};

export const oneShotIt = {
  [pageNameKey]: { oneShotAltText: "One Shot" },
};

export const oneShotEs = {
  [pageNameKey]: { oneShotAltText: "Un solo intento" },
};

export const oneShotNl = {
  [pageNameKey]: {
    oneShotAltText: "Eenmalig",
  },
};

export const oneShotTr = {
  [pageNameKey]: {
    oneShotAltText: "Tek Atış",
  },
};
